export const SETTINGS_PATH = '/settings';
export const SETTINGS_SCOPE_QUERY_PARAM = 'scope';
export const SETTINGS_SCOPE = Object.freeze({
    ACCOUNT: 'account',
});
export const SETTINGS_SECTION = Object.freeze({
    EDIT_PROFILE: 'edit-profile',
    CHANGE_PASSWORD: 'change-password',
    BILLING: 'billing',
    INTERFACE_LANGUAGE: 'interface-language',
    COURSE_DETAILS: 'course-details',
    GRADING: 'grading',
    FEEDBACK: 'feedback',
    INLINE_COMMENTS: 'inline-comments',
});

export const CHANGE_PASSWORD_FIELD = Object.freeze({
    CURRENT: 'current',
    NEW: 'new',
    CONFIRM_NEW: 'confirmNew',
});

// Form field names used by the settings autosave hooks. Keeping these here
// prevents UI event handlers from depending on untyped, duplicated literals.
export const COURSE_DETAILS_FIELD = Object.freeze({
    NAME: 'name',
    LANGUAGE: 'language',
});

export const EDIT_PROFILE_FIELD = Object.freeze({
    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name',
    DISPLAY_NAME: 'display_name',
    EMAIL: 'email',
    PROFILE_IMAGE: 'profile_image',
    PROFILE_CIRCLE: 'profile_circle',
    PRONOUN: 'pronoun',
    ENGLISH_PROFICIENCY: 'english_proficiency',
    COUNTRY: 'country',
    TIMEZONE: 'timezone',
});

export const EDIT_PROFILE_SELECT_FIELDS = Object.freeze([
    EDIT_PROFILE_FIELD.PRONOUN,
    EDIT_PROFILE_FIELD.ENGLISH_PROFICIENCY,
    EDIT_PROFILE_FIELD.COUNTRY,
    EDIT_PROFILE_FIELD.TIMEZONE,
]);

export const getSettingsPath = ({ sectionId, scope } = {}) => {
    const search = scope ? `?${SETTINGS_SCOPE_QUERY_PARAM}=${scope}` : '';
    const hash = sectionId ? `#${sectionId}` : '';

    return `${SETTINGS_PATH}${search}${hash}`;
};
